import styles from "./breadcrumbs.module.scss";
import Link from "@/components/Link";
import { useRouter } from "next/router";
import { toTitleCase } from "@/helpers/utils";

const Breadcrumbs = () => {
  const router = useRouter();
  const segments = router.asPath
    ?.split("?")[0]
    ?.split("/")
    .filter((s) => s !== "");

  return (
    <div className={styles.breadcrumbs}>
      {segments?.map((segment, i) => {
        const fullPath = segments.slice(0, i + 1).join("/");
        return (
          <Link key={i} href={`/${fullPath}/`} className={styles.link}>
            {toTitleCase(segment)}
          </Link>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
